import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Reports, Training } from '../app.urls';
import { TableUtil } from "../shared/tableUtil";
import { environment } from 'src/environments/environment';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient, private loaderService: LoaderService) { }
  public routeToReportObs = new BehaviorSubject<any>(true);
  public videoIcon = new BehaviorSubject<any>(true);
  public isVideoIconHide = new BehaviorSubject<any>(false);
  public reportDashboard = new BehaviorSubject<any>(true);

  // this function is fetching time zones data from api
  getTimeZone(): Observable<any> | null {
    return this.http.get<any>(Reports.TimeZone + 'gettimezonelist')
  }

  // Schedule landing page api
  getSchedules(collectionId: any): Observable<any> | null {
    return this.http.get<any>(Reports.Schedules + 'schedule-landing?collectionId=' + collectionId)
  }

  // Schedule report (landing page) filter api
  scheduleReportFilter(collectionId, filterObj) {
    const addTagApiUrl =
      Reports.ScheduleReportFilter + '?collectionId=' + collectionId +
      '&fromDate=' + filterObj.fromDate + '&toDate=' + filterObj.todate +
      '&scheduleName=' + filterObj.scheduleName + '&testName=' + filterObj.testNameFilter  + '&schStatus=' + filterObj.schStatus;
    return this.http.get<any>(addTagApiUrl)
  }

  // Class report (landing page) filter api
  classReportFilter(filterObj, collectionId) {
    const ApiUrl = `${Reports.classReportFilter}?collectionid=${collectionId}&classname=${filterObj.className}&testname=${filterObj.testName}&startdate=${filterObj.startDate}&enddate=${filterObj.enddate}`;
    return this.http.get<any>(ApiUrl)
  }

  // Class detailed report api
  classDetailedReport(classId, collectionId, attemptNumber) {
    let attemptNumber1 = attemptNumber == ''? '-1' : attemptNumber
    const ApiUrl = `${Reports.classWiseReport}?collectionid=${collectionId}&classid=${classId}&attemptNumber=${attemptNumber1}`;
    return this.http.get<any>(ApiUrl)
  }

  // Attendance report page api
  getAttendance(schIdId: any): Observable<any> | null {
    const fetchAttendanceApiUrl = Reports.getAttendanceData + '?scheduleId=' + schIdId;
    return this.http.get<any>(fetchAttendanceApiUrl)
  }

  //attendance report filter
  attendanceReportFilter(scheduleId, filterObj) {
    const addTagApiUrl =
      Reports.getAttendanceData + '?scheduleId=' + scheduleId +
      '&examineeName=' + filterObj.examineeName +
      '&attendance=' + filterObj.attendance;

    return this.http.get<any>(addTagApiUrl)
  }


  // Examinee score report api
  getExamineeScoreReport(collectionId: any, scheduleId: any): Observable<any> | null {
    const fetchExamineescoreApiUrl = Reports.Schedules + 'examinee/' + 'score?collectionId=' + collectionId +
      // '&examineeId=' + examineeId +
      '&scheduleId=' + scheduleId;
    return this.http.get<any>(fetchExamineescoreApiUrl)
  }

  //examinee score report filter
  examineeScoreReportFilter(scheduleId, filterObj, collectionId) {
    // const addTagApiUrl =
    //   Reports.Schedules + 'score?examineeName=' + filterObj.examineeName + '&scheduleId=' + scheduleId;
    // return this.http.get<any>(addTagApiUrl)

    const fetchExamineescoreApiUrl = Reports.Schedules + 'examinee/' + 'score?collectionId=' + collectionId + '&scheduleId=' + scheduleId + '&examineeName=' + filterObj.uuid;

    return this.http.get<any>(fetchExamineescoreApiUrl)

  }

  // Examinee detailed score report api
  getExamineeDetailedScore(examId: any, schIdId: any, attemptNumber: any): Observable<any> | null {
    const currentUserFromStorage = JSON.parse(
      sessionStorage.getItem('currentUser') || '{}'
    );

    const clientuuId = currentUserFromStorage.clientuuId;
    const globalcollectionid = JSON.parse(
      sessionStorage.getItem('defaultcollectionid')
    );
    const fetchAttendanceApiUrl = Reports.ExamineeDetailedScore + 'details?scheduleId=' + schIdId + '&' + 'examineeId=' + examId + '&clientuuId=' + clientuuId + '&' + 'collectionId=' + globalcollectionid + '&attemptNumber=' + attemptNumber;

    return this.http.get<any>(fetchAttendanceApiUrl)
  }

  // Examinee landing page api
  //examinee detailed score report filter
  examineeDetailedScoreReportFilter(scheduleId, examineeId, filterObj) {
    const currentUserFromStorage = JSON.parse(
      sessionStorage.getItem('currentUser') || '{}'
    );

    const clientuuId = currentUserFromStorage.clientuuId;
    const globalcollectionid = JSON.parse(
      sessionStorage.getItem('defaultcollectionid')
    );
    const addTagApiUrl =
      Reports.ExamineeDetailedScore + 'details?scheduleId=' + scheduleId + '&' + 'examineeId=' + examineeId +
      '&itemName=' + filterObj.itemName +
      '&AnswerResult=' + filterObj.answerResult + '&clientuuId=' + clientuuId + '&' + 'collectionId=' + globalcollectionid + '&attemptNumber=' + filterObj.attemptNumber;

    return this.http.get<any>(addTagApiUrl)
  }

  // Examinee landing page api
  getExaminee(collectionId: any): Observable<any> | null {
    const fetchExamineeApiUrl = Reports.Schedules + 'examinee-landing?collectionId=' + collectionId;
    return this.http.get<any>(fetchExamineeApiUrl)
  }
  // Examinee report (landing page) filter api

  examineeReportFilter(collectionId, filterObj) {
    const addTagApiUrl =
      Reports.ExamineeReportFilter + '?collectionId=' + collectionId + '&emailId=' + filterObj.emailId + '&firstName=' + filterObj.firstName + '&lastName=' + filterObj.lastName; '&scheduleName=' + filterObj.scheduleName + '&testName=' + filterObj.testNameFilter;
    return this.http.get<any>(addTagApiUrl)
  }




  //Examinee Test Report api
  getExamineeTestReport(examId: any): Observable<any> | null {
    const collectionId = sessionStorage.getItem('defaultcollectionid');
    const fetchAttendanceApiUrl = Reports.ExamineeTestReport + 'test?examineeId=' + examId + '&collectionId=' + collectionId;
    return this.http.get<any>(fetchAttendanceApiUrl)
  }
  //Examinee Test Report filter api
  examineeTestReportFilter(collectionId, examineeId, filterObj) {
    const addTagApiUrl =
      Reports.ExamineeTestReport + 'test?collectionId=' + collectionId + '&' + 'examineeId=' + examineeId +
      '&fromDate=' + filterObj.scheduleStartdate + '&toDate=' + filterObj.scheduleEnddate +
      '&scheduleName=' + filterObj.scheduleName +
      '&attendance=' + filterObj.attendance +
      '&result=' + filterObj.result;
    ;
    return this.http.get<any>(addTagApiUrl)
  }

  //Examinee detailed report api
  getExamineeDetailedReport(schIdId: any, examId: any, attemptNumber): Observable<any> | null {
    const currentUserFromStorage = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    const clientuuId = currentUserFromStorage?.clientuuId;
    const fetchAttendanceApiUrl = Reports.ExamineeDetailedReport + 'details?clientuuId=' + clientuuId + '&' + 'scheduleId=' + schIdId
      + '&' + 'examineeId=' + examId + '&attemptnumber=' + attemptNumber;
    return this.http.get<any>(fetchAttendanceApiUrl)
  }

  //Examinee detailed report filter api
  examineeDetailedReportFilter(scheduleId, examineeId, filterObj, attemptNumber) {
    const currentUserFromStorage = JSON.parse(
      sessionStorage.getItem('currentUser') || '{}'
    );

    const clientuuId = currentUserFromStorage?.clientuuId;
    const addTagApiUrl =
      Reports.ExamineeDetailedReport + 'details?clientuuId=' + clientuuId + '&' + 'scheduleId=' + scheduleId
      + '&' + 'examineeId=' + examineeId +
      '&itemName=' + filterObj.itemName +
      '&questionAnswerd=' + filterObj.questionAnswerd + '&attemptNumber=' + attemptNumber;;
    return this.http.get<any>(addTagApiUrl)
  }

  // This service method used to get item report list
  getItemReport(collectionId: string, schduleId: number, selectedAttempte: any): Observable<any> | null {
    const fetchItemApiUrl = Reports.ItemReport + 'items?collectionId=' + collectionId + '&schduleId=' + schduleId + '&attemptNumber=' + selectedAttempte;
    return this.http.get<any>(fetchItemApiUrl)
  }

  // This service method used for item report filter purpose on item report page
  itemReportFilter(collectionId: string, schduleId: number, itemName: string, attemptNumber): Observable<any> | null {
    const fetchItemApiUrl = Reports.ItemReport + 'items?collectionId=' + collectionId + '&schduleId=' + schduleId + '&itemName=' + itemName + '&attemptNumber=' + attemptNumber;
    return this.http.get<any>(fetchItemApiUrl)
  }

  exportTable(eleReportName: any, tableData: any, headerData: any, filename: string) {

    // building report initial letters
    const buildReportName = eleReportName.nativeElement.childNodes[0].data.split(' ');
    let reportName = buildReportName.map(([v]) => v);
    reportName = reportName.splice(0, reportName.length - 1).join('').toUpperCase();

    // calling excel file building function
    TableUtil.exportArrayToExcel(tableData, headerData, `${filename}`);
  }

  getDescriptiveQuestionEvaluationDetails(scheduleId: any) {
    const fetchExamineescoreApiUrl = Reports.DescriptiveQuestionEvaluationDetails + 'descriptive-question-evaluation?scheduleId=' + scheduleId;
    return this.http.get<any>(fetchExamineescoreApiUrl)
  }

  getPublicFilterDescriptiveQuestionEvaluationDetails(scheduleId: any,item:any) {
    const fetchExamineescoreApiUrl = Reports.DescriptiveQuestionEvaluationDetails + 'descriptive-question-evaluation?scheduleId=' + scheduleId + '&examineeName=' + item.uuid;
    return this.http.get<any>(fetchExamineescoreApiUrl)
  }

 getPrivateFilterDescriptiveQuestionEvaluationDetails(scheduleId: any,item:any) {
    const fetchExamineescoreApiUrl = Reports.DescriptiveQuestionEvaluationDetails + 'descriptive-question-evaluation?scheduleId=' + scheduleId + '&examineeName=' + item.examineeName;
    return this.http.get<any>(fetchExamineescoreApiUrl)
  }

  getStartEvaluateDescriptiveQuestion(scheduleId: any, examineeId: any, userTestid: any) {
    const fetchDescriptiveEvaluateApiUrl = Reports.StartEvaluateDescriptiveQuestion + 'start-question-evaluation?scheduleId=' + `${scheduleId}&examineeId=${examineeId}&userTestid=${userTestid}`;

    return this.http.get<any>(fetchDescriptiveEvaluateApiUrl)
  }

  getResponseOverview(scheduleId: any, attemptNumber: any) {
    return this.http.get<any>(Reports.ResponseOverview + `?scheduleId=${scheduleId}&attemptNumber=${attemptNumber}`);
  }

  getFilterResponseReport(scheduleId: any, filterObj: any) {
    const fetchResponseApi = Reports.ResponseItemList + `?scheduleId=${scheduleId}` + '&itemName=' + filterObj.itemName + '&attemptNumber=' + filterObj.attemptNumber;
    return this.http.get<any>(fetchResponseApi)
  }

  getResponseItemList(scheduleId: any, attemptNumber: any) {
    return this.http.get<any>(Reports.ResponseItemList + `?scheduleId=${scheduleId}&attemptNumber=${attemptNumber}`);
  }

  getQuestionsReport(scheduleId: any, itemId: any, questionId: any, stemId: number = 0, attemptNumber: number) {
    let param = `scheduleId=${scheduleId}&itemId=${itemId}&questionId=${questionId}&attemptNumber=${attemptNumber}`;
    if (stemId > 0) {
      param = `${param}&stemId=${stemId}`
    }
    return this.http.get<any>(Reports.ResponseReportDetails + `?${param}`);
  }

  getDetailedReport(startDate, endDate) {
    return this.http.get<any>(Reports.DetailedReport + `?startdate=${startDate}&enddate=${endDate}`);
  }

  getAttendenceList() {
    return this.http.get<any>(Reports.AttendenceList);
  }

  getAnswerResultList() {
    return this.http.get<any>(Reports.answerResultList);
  }

  exportToExcel(scheduleId: any, fileType: string, selectedAttempt): Observable<any> {
    let fileExtension = fileType;
    let pyalod = Reports.exportToExcel + `?scheduleId=${scheduleId}&attemptNumber=${selectedAttempt}`
    this.loaderService.showloaderMsg(true);
    return this.http.get(pyalod, {

      responseType: 'blob',
      observe: 'response'
    })
      .pipe(map((res: any) => {
        this.loaderService.showloaderMsg(false);
          return new Blob([res.body], { type: fileExtension });
        })
      );
  }

  videoTutorial(assetGroup) {
    return this.http.get<any>(Training.tutorial + assetGroup);
  }

  getSummaryReportData(fromDate, toDate, globalCollectionId) {
    return this.http.get<any>(Reports.summaryReport + `?collectionid=${globalCollectionId}&startdate=${fromDate}&enddate=${toDate}`);
  }

  getIntructorReportData(fromDate, toDate, CollectionId) {
    return this.http.get<any>(Reports.InstructorReport + `?collectionid=${CollectionId}&startdate=${fromDate}&enddate=${toDate}`)
  }

  getScheduleStatus() {
    return this.http.get<any>(Reports.ScheduleStatus);
  }

  getReportDashboard(CollectionId) {
    return this.http.get<any>(`${Reports.DashBoard}?collectionId=${CollectionId}`);
  }

}
